import { LocationQueryValue } from "vue-router"

import { ensureStartsWithMyAccountPath } from "./websiteUrls"

const isAbsoluteUrl = (url: string) => url.startsWith("https")

export function getRedirectUrl(
  redirectParam: LocationQueryValue | LocationQueryValue[],
) {
  const redirectPath = Array.isArray(redirectParam)
    ? redirectParam[0]
    : redirectParam
  if (!redirectPath) return

  if (isAbsoluteUrl(redirectPath)) {
    return redirectPath
  }

  return ensureStartsWithMyAccountPath(redirectPath)
}
